import Icons from "../../../shared/constants/icon.constant";

import ProfileLayout from "../layouts/ProfileLayout";
import CertificatesAndAchievement from "../pages/CertificatesAndAchievement";
import CourseAndChapterCompletitionHistory from "../pages/CourseAndChapterCompletitionHistory";
import HelpAndSupport from "../pages/HelpAndSupport";
import MembershipLevel from "../pages/MembershipLevel";
import PasswordSetting from "../pages/PasswordSetting";
import ComingSoon from "@/shared/components/ComingSoon";
import ProfileSetting from "../pages/ProfileSetting";
import AffiliateProgram from "../pages/AffiliateProgram";

const profileRoutes = {
  path: "dashboard/profile",
  label: "Profile",
  element: <ProfileLayout />,
  children: [
    {
      path: "setting",
      label: "Profile Settings",
      icon: Icons.InfoIcon({ width: 16, height: 16 }),
      element: <ProfileSetting />,
    },
    {
      path: "wallet",
      label: "Wallet",
      icon: Icons.Wallet({ width: 16, height: 16 }),
      element: <ComingSoon />,
      comingSoon: true,
    },
    {
      path: "membership-level",
      label: "Membership Level",
      icon: Icons.Course({ width: 16, height: 16 }),
      element: <MembershipLevel />,
    },
    {
      path: "password-setting",
      label: "Password Settings",
      icon: Icons.Edit({ width: 16, height: 16 }),
      element: <PasswordSetting />,
    },
    {
      path: "notification-setting",
      label: "Notification Settings",
      icon: Icons.Notifications({ width: 16, height: 16 }),
      element: <ComingSoon />,
      comingSoon: true,
    },
    {
      path: "help-and-support",
      label: "Help & Support",
      icon: Icons.InfoIcon({ width: 16, height: 16 }),
      element: <HelpAndSupport />,
    },
    {
      path: "course-and-chapter-completion-history",
      label: "Course and Chapter Completion History",
      icon: Icons.Learning({ width: 16, height: 16 }),
      element: <CourseAndChapterCompletitionHistory />,
    },
    {
      path: "certificate-and-achievement",
      label: "Certificates & Achievements",
      icon: Icons.Bookmarks({ width: 16, height: 16 }),
      element: <CertificatesAndAchievement />,
    },
    {
      path: "affiliate-program",
      label: "Referral Program",
      icon: Icons.AffiliateProgram({ width: 16, height: 16 }),
      element: <AffiliateProgram />,
    },
  ],
};

export default profileRoutes;
